import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-grey-900 mb-3"
}
const _hoisted_8 = { class: "s3_mobile h-100p px-2" }
const _hoisted_9 = { class: "font-normal mb-5" }
const _hoisted_10 = { class: "s4_mobile h-100p px-3" }
const _hoisted_11 = { class: "font-normal" }
const _hoisted_12 = { class: "text-2xl" }
const _hoisted_13 = { class: "s7_mobile h-100p px-5" }
const _hoisted_14 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_15 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_16 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_17 = { class: "s20 flex gap-5" }
const _hoisted_18 = { class: "s6_mobile" }
const _hoisted_19 = { class: "card-carte" }
const _hoisted_20 = { class: "card-carte-floating" }
const _hoisted_21 = {
  key: 0,
  class: "s20"
}
const _hoisted_22 = { class: "flex align-items-center gap-2" }
const _hoisted_23 = { class: "secondary-font text-6xl" }
const _hoisted_24 = { class: "card-carte-floating-bottom" }
const _hoisted_25 = { class: "s10 secondary-font font-bold" }
const _hoisted_26 = {
  key: 1,
  class: "s20"
}
const _hoisted_27 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_28 = { class: "text-3xl text-grey-800" }
const _hoisted_29 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_30 = { class: "text-3xl text-grey-800" }
const _hoisted_31 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_32 = { class: "text-3xl text-grey-800" }
const _hoisted_33 = { class: "s7_mobile px-6" }
const _hoisted_34 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_35 = { class: "text-3xl text-grey-800" }
const _hoisted_36 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_37 = { class: "text-3xl text-grey-800" }
const _hoisted_38 = { class: "s20 collapse-content pb-7 active" }
const _hoisted_39 = { class: "s7 px-8" }
const _hoisted_40 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_41 = { class: "text-3xl text-grey-800" }
const _hoisted_42 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_43 = { class: "text-3xl text-grey-800" }
const _hoisted_44 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_45 = { class: "text-3xl text-grey-800" }
const _hoisted_46 = { class: "s7 px-8" }
const _hoisted_47 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_48 = { class: "text-3xl text-grey-800" }
const _hoisted_49 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_50 = { class: "text-3xl text-grey-800" }
const _hoisted_51 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_52 = { class: "text-3xl text-grey-800" }
const _hoisted_53 = { class: "text-3xl text-grey-800" }

import { useRoute } from 'vue-router';
    import { computed, inject, onMounted, ref } from 'vue';
    import { formatAmount, formatDate, formatDateFrench, MONTHS_FR } from '@/utils';
    import moment from 'moment';
    import UserPrelevementsMensuels from './@components/UserPrelevementsMensuels.vue';
    import UserPlanMensuel from './@components/UserPlanMensuel.vue';
import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersPlanView',
  setup(__props) {

    const route = useRoute();
    const user: any = route.meta.user;
    const souscription: any = route.meta.souscription;
    const carte: any = route.meta.carte;

    const loadingPlanMensuel = ref(false);
    const errorPlanMensuel = ref('');
    const dateDebut = ref(null as string | null);
    const dateFin = ref(null as string | null);
    const planMensuelsDatas = ref([] as { plan: any, title: string, offset: number }[]);

    onMounted(() => {
        if (user.souscription) {
            fetchPlanMensuelDatas();
        }
    })

    async function fetchPlanMensuelDatas() {
        try {
            loadingPlanMensuel.value = true;

            const responses = await Promise.all([
                axios.post(`/backoffice/users/${user.id}/plan/get_planmensuel_datas`, { souscription_id: user.souscription.id, offset: 0 }),
                axios.post(`/backoffice/users/${user.id}/plan/get_planmensuel_datas`, { souscription_id: user.souscription.id, offset: 1 }),
                axios.post(`/backoffice/users/${user.id}/plan/get_planmensuel_datas`, { souscription_id: user.souscription.id, offset: 2 }),
            ]);
            const datas = responses.filter(r => r.data).map(r => r.data);
            datas.forEach((data, index) => {
                planMensuelsDatas.value.push({
                    plan: data.plan_mensuel,
                    title: getTitlePlanMensuel(data.date_debut, data.date_fin, index),
                    offset: index
                })
            });

            /*const offsetParams = 0;
            const response = await axios.post(`/backoffice/users/${user.id}/plan/get_planmensuel_datas`, { souscription_id: user.souscription.id, offset: offsetParams });
            planMensuel.value = response.data.plan_mensuel;
            souscription.value = response.data.souscription;
            dateDebut.value = response.data.date_debut;
            dateFin.value = response.data.date_fin;*/
        } catch (err: any) {
            errorPlanMensuel.value = err;
        } finally {
            loadingPlanMensuel.value = false;
        }
    }

    function getTitlePlanMensuel(dateDebut: string, dateFin: string, offset: number) {
        const dateDebutM = moment(dateDebut);
        const dateFinM = moment(dateFin);

        return `Année ${(offset + 1)} / ${MONTHS_FR[dateDebutM.month()]} ${dateDebutM.format('YYYY')} - ${MONTHS_FR[dateFinM.month()]} ${dateFinM.format('YYYY')}`;
    }

    const quotiteUsedPercent = computed(() => {
        if (!user || !user.quotite_cessible_montant || !user.salaire || user.salaire <= 0) return 0;
        // Si on a une utilisation, on peut la calculer, sinon 0
        // Pour l'instant, on retourne 0 car on n'a pas de données d'utilisation
        return 0;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[54] || (_cache[54] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / Plan Mensuel <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Prélèvement mensuel</span><span class=\"btn shadow-200 light2 border-none\">Données financières</span><span class=\"btn shadow-200 light2 border-none\">Plan Mensuel 1</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: !!_unref(user).photo_url ? _unref(user).photo_url : '/assets/users_avatar/600w/user.jpg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(user).kyc?.id)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, "n° CF" + _toDisplayString(_unref(user).created_at ? _unref(moment)(_unref(user).created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(_unref(user).kyc.id).padStart(6, '0')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h4", null, _toDisplayString(_unref(user).nom + ' ' + _unref(user).prenom), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(user).collectivite?.nom), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h4", _hoisted_11, [
          _cache[2] || (_cache[2] = _createTextVNode(" Date de fin de souscription ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
          _createElementVNode("b", _hoisted_12, _toDisplayString(_unref(souscription) ? _unref(formatDateFrench)(_unref(souscription).date_fin) : '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation", -1)),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: _normalizeStyle({'width': quotiteUsedPercent.value + '%'})
          }, _toDisplayString(quotiteUsedPercent.value) + "% ", 5)
        ])
      ])
    ]),
    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    (_unref(souscription))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(UserPrelevementsMensuels, {
            "user-id": _unref(user).id
          }, null, 8, ["user-id"]),
          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
          _createElementVNode("div", _hoisted_15, [
            _cache[47] || (_cache[47] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Données financières </span></div><div class=\"s10 mt--5-5 flex-right gap-3\"></div><div class=\"clear-both h-5\"></div>", 3)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_unref(carte))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "secondary-font font-bold mb-3" }, "Solde utilisable", -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("h1", _hoisted_23, _toDisplayString(_unref(formatAmount)(_unref(carte).solde)), 1),
                              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "secondary-font text-4xl mt-2" }, "F", -1)),
                              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mt-2 ml-2" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-eye-off.svg",
                                  class: "size-medium icon-white"
                                })
                              ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("h5", _hoisted_25, _toDisplayString(_unref(carte).numero_masque), 1),
                              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "s10 flex-right align-items-center gap-2" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-edit.svg",
                                  class: "size-medium icon-white"
                                }),
                                _createElementVNode("h5", { class: "secondary-font font-bold" }, "Commerce")
                              ], -1))
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("img", {
                              src: "/images/carte_coop_light.png",
                              class: "card-carte-img",
                              style: {"width":"100%"}
                            }, null, -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("h5", { class: "secondary-font font-bold mb-3" }, "Aucune carte disponible", -1)
                          ]))]))
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["s7_mobile px-6", {'s7_mobile': _unref(carte), 's10_mobile': !_unref(carte)}])
                }, [
                  _createElementVNode("h4", _hoisted_27, [
                    _cache[11] || (_cache[11] = _createTextVNode(" Salaire ", -1)),
                    _cache[12] || (_cache[12] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_28, _toDisplayString(_unref(formatAmount)(_unref(souscription).salaire)), 1)
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_29, [
                    _cache[13] || (_cache[13] = _createTextVNode(" Prélèvement sur salaire % ", -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_30, _toDisplayString(_unref(souscription).prelevement_pourcent) + "%", 1)
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_31, [
                    _cache[15] || (_cache[15] = _createTextVNode(" Prélèvement sur salaire ", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_32, _toDisplayString(_unref(formatAmount)(_unref(souscription).prelevement_montant)), 1)
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1))
                ], 2),
                _createElementVNode("div", _hoisted_33, [
                  _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                    _createTextVNode(" Ans pour la Retraite"),
                    _createElementVNode("br", { class: "mb-4" }),
                    _createElementVNode("b", { class: "text-3xl text-grey-800" }, "N/A")
                  ], -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_34, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Quote cessible %", -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_35, _toDisplayString(_unref(souscription).quotite_cessible_pourcent) + "%", 1)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_36, [
                    _cache[22] || (_cache[22] = _createTextVNode(" Quote cessible", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_37, _toDisplayString(_unref(formatAmount)(_unref(souscription).quotite_cessible_montant)), 1)
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("hr", null, null, -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"s6 px-8\"><h4 class=\"font-normal text-grey-500 text-center py-3\"> Taux Interets Microfinance<br class=\"mb-4\"><b class=\"text-3xl text-grey-800\">N/A</b></h4><hr><h4 class=\"font-normal text-grey-500 text-center py-3\"> Pret à Rembourser apres 3 Ans<br class=\"mb-4\"><b class=\"text-3xl text-grey-800\">N/A</b></h4><hr><h4 class=\"font-normal text-grey-500 text-center py-3\"> Cash-Back TVA Attendu<br class=\"mb-4\"><b class=\"text-3xl text-grey-800\">N/A</b></h4></div>", 1)),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("h4", _hoisted_40, [
                  _cache[28] || (_cache[28] = _createTextVNode(" Prêt en Concession", -1)),
                  _cache[29] || (_cache[29] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("b", _hoisted_41, _toDisplayString(_unref(formatAmount)(_unref(souscription).pret_concession)), 1)
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("h4", _hoisted_42, [
                  _cache[30] || (_cache[30] = _createTextVNode(" Prélèvement à la Solde", -1)),
                  _cache[31] || (_cache[31] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("b", _hoisted_43, _toDisplayString(_unref(formatAmount)(_unref(souscription).prelevement_solde)), 1)
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("h4", _hoisted_44, [
                  _cache[32] || (_cache[32] = _createTextVNode(" Pret à Rembourser", -1)),
                  _cache[33] || (_cache[33] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("b", _hoisted_45, _toDisplayString(_unref(formatAmount)(_unref(souscription).pret_rembourser)), 1)
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1))
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("h4", _hoisted_47, [
                  _cache[37] || (_cache[37] = _createTextVNode(" Pouvoir Achat 1 An", -1)),
                  _cache[38] || (_cache[38] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("b", _hoisted_48, _toDisplayString(_unref(formatAmount)(_unref(souscription).pouvoir_achat_an)), 1)
                ]),
                _cache[44] || (_cache[44] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("h4", _hoisted_49, [
                  _cache[39] || (_cache[39] = _createTextVNode(" Pouvoir Achat 3 Ans", -1)),
                  _cache[40] || (_cache[40] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("b", _hoisted_50, _toDisplayString(_unref(formatAmount)(_unref(souscription).pouvoir_achat)), 1)
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("h4", _hoisted_51, [
                  _cache[41] || (_cache[41] = _createTextVNode(" Durée Financement ", -1)),
                  _cache[42] || (_cache[42] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("b", _hoisted_52, _toDisplayString(_unref(souscription).duree_mois) + " Mois", 1),
                  _cache[43] || (_cache[43] = _createTextVNode(" - ", -1)),
                  _createElementVNode("b", _hoisted_53, _toDisplayString(parseInt((parseInt(_unref(souscription).duree_mois) / 12).toString())) + " ans", 1)
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    (_unref(user).souscription)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(planMensuelsDatas.value, (plan_mensuel, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createVNode(UserPlanMensuel, {
              "plan-mensuel": plan_mensuel.plan,
              title: plan_mensuel.title
            }, null, 8, ["plan-mensuel", "title"]),
            (index + 1 < planMensuelsDatas.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[51] || (_cache[51] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
                  _cache[52] || (_cache[52] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
                  _cache[53] || (_cache[53] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1))
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      : _createCommentVNode("", true),
    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "clear-both h-40" }, null, -1))
  ]))
}
}

})